module.exports = __webpack_public_path__ + "static/media/Nym.57798424.png";